<template>
  <div class="styleguide ">
    <div class="container">
      <Title size="xl">Title XL</Title>
      <Title size="l">Title L</Title>
      <Title size="m">Title M</Title>
      <Title size="s">Title S</Title>
      <Title size="xs">Title XS</Title>
      <ui-button icon="google" size="xs">Button with icon</ui-button>
      <ui-button icon="google" size="s">Button with icon</ui-button>
      <ui-button icon="google" size="m">Button with icon</ui-button>
      <ui-button icon="google" size="l">Button with icon</ui-button>
      <div />
      <ui-button icon="google" size="xs" outline>Button with icon</ui-button>
      <ui-button icon="google" size="s" outline>Button with icon</ui-button>
      <ui-button icon="google" size="m" outline>Button with icon</ui-button>
      <ui-button icon="google" size="l" outline>Button with icon</ui-button>
      <div />
      <ui-button icon="google" size="xs" color="google"
        >Button with icon</ui-button
      >
      <ui-button icon="google" size="s" color="google"
        >Button with icon</ui-button
      >
      <ui-button icon="facebook" size="m" color="facebook"
        >Button with icon</ui-button
      >
      <ui-button icon="google" size="l" color="google"
        >Button with icon</ui-button
      >
      <div />
      <ui-button icon="google" size="xs" outline color="red"
        >Button with icon</ui-button
      >
      <ui-button icon="google" size="l" outline color="red"
        >Button with icon</ui-button
      >
      <ui-button icon="google" size="m" outline color="red"
        >Button with icon</ui-button
      >
      <ui-button icon="google" size="s" outline color="red"
        >Button with icon</ui-button
      >
      <div />
      <ui-button icon="google" text>text button with icon</ui-button>
      <div />
      <ui-button text>text button </ui-button>
      <ui-button text color="primary" icon="google">text button </ui-button>
      <ui-button text color="red">text button </ui-button>
      <ui-button text color="blue">text button </ui-button>
      <ui-button text color="green">text button </ui-button>
      <ui-button text color="facebook" icon="facebook">text button </ui-button>
      <div />
      <ui-button size="xs">xs button</ui-button>
      <ui-button size="s">s button</ui-button>
      <ui-button size="m">m button</ui-button>
      <ui-button size="l">l button</ui-button>
      <ui-button size="xl">xl button</ui-button>
      <div />
      <ui-button color="black">button</ui-button>
      <ui-button color="green">button</ui-button>
      <ui-button color="red">button</ui-button>
      <ui-button color="primary">button</ui-button>
      <ui-button color="gray">button</ui-button>
      <ui-button color="blue">button</ui-button>
      <div />
      <ui-button color="black" outline>button</ui-button>
      <ui-button color="green" outline>button</ui-button>
      <ui-button color="red" outline>button</ui-button>
      <ui-button color="primary" outline>button</ui-button>
      <ui-button color="gray" outline>button</ui-button>
      <ui-button color="blue" outline>button</ui-button>
      <div />
      <ui-button size="xs" alt>xs button</ui-button>
      <ui-button size="s" alt>s button</ui-button>
      <ui-button size="m" alt>m button</ui-button>
      <ui-button size="l" alt>l button</ui-button>
      <ui-button size="xl" alt>xl button</ui-button>
      <div />
      <ui-button size="xs" icon="love" color="primary">xs button</ui-button>
      <ui-button size="s" icon="love" color="primary">s button</ui-button>
      <ui-button size="m" icon="love" color="primary">m button</ui-button>
      <ui-button size="l" icon="love" color="primary">l button</ui-button>
      <ui-button size="xl" icon="love" color="primary">xl button</ui-button>
      <div />
      <ui-button :loading="true">Loading button</ui-button>
      <div />
      <ui-button size="xs" icon="love" color="primary" outline
        >xs button</ui-button
      >
      <ui-button size="s" icon="love" color="primary" outline
        >s button</ui-button
      >
      <ui-button size="m" icon="love" color="primary" outline
        >m button</ui-button
      >
      <ui-button size="l" icon="love" color="primary" outline
        >l button</ui-button
      >
      <ui-button size="xl" icon="love" color="primary" outline
        >xl button</ui-button
      >
      <div />
      <ui-button icon="love" />
      <ui-button icon="love" round />
      <ui-button icon="love" round outline />
      <ui-button icon="love" round outline :loading="true" />

      <div />

      <ui-button icon="love" size="s" iconPosition="top" color="primary">
        Love
      </ui-button>
      <ui-button icon="share" size="s" iconPosition="top" text>
        Share
      </ui-button>
    </div>
  </div>
</template>
<script>
import UiButton from "@/components/ui/UiButton.vue";
import Title from "@/components/ui/Title.vue";
export default {
  components: { Title, UiButton },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    handleClick() {
      this.loading = !this.loading;
    },
  },
};
</script>
<style lang="scss" scoped>
.styleguide {
  margin-top: 20px;
  ::v-deep .btn {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.space {
  height: 10px;
}
</style>
